import React from 'react';

const SplashMessage = props => {
  const { message } = props;
  if (message)
    return (
      <div className={`splash-message__wrap ${message.className}`}>
        <p className={`splash-message p ${message.className}`}>
          {message.message}
        </p>
      </div>
    );
};

export default SplashMessage;



// WEBPACK FOOTER //
// ./src/components/splashMessage/SplashMessage.js